(function(){
'use strict';

angular.module('classy').component('cpPaymentWidget', {
  template: '\n  <div class="donation-payment-method-select row" ng-hide="$ctrl.hideButtons"> \n    <div class="eg-payment-button-mask" data-ng-show="!$ctrl.arePaymentButtonEnabled"></div>\n    <div class="column-md-7">\n      <summary-amount \n      amount="$ctrl.meta.summaryAmount"\n      recur_until="$ctrl.parentModel.recur_until"\n      feeprocessing="$ctrl.feeProcessing" \n      frequency="$ctrl.parentModel.frequency" \n      taxcompliance="$ctrl.meta.unsupportedTaxCompliance"\n      currency="$ctrl.parentModel.payment.raw_currency_code"\n      estimatedcharge="$ctrl.meta.estimatedCharge"></summary-amount>\n      \n      <fee-on-top fot="$ctrl.parentModel.fee_on_top"></fee-on-top>\n    </div>\n    <div class="column-md-5">\n      <small class="cp-payment-widget__terms" ng-bind-html="$ctrl.terms()"></small>\n\n      <cp-digital-wallets\n        data-ng-if="!$ctrl.isTrial"\n        frequency="$ctrl.parentModel.frequency"\n        amount="$ctrl.getAmount()"\n        currency="$ctrl.parentModel.payment.raw_currency_code"\n        submit="$ctrl.submitDigitalWallets"\n        pay-type="$ctrl.meta.digitalWalletType"\n        fot="$ctrl.parentModel.fee_on_top"\n        classyMode="$ctrl.isClassyMode"\n        validate-form="$ctrl.validateForm()"\n      ></cp-digital-wallets>\n\n      <cp-paypal-widget\n        data-ng-if="$ctrl.show.paypal() && !$ctrl.isTrial"\n        model="$ctrl.payment.paypal"\n        sc-validity-reporter\n        ng-model="$ctrl.payment.paypal.status"\n        on-ready="$ctrl.onPaypalReady()"\n        on-success="$ctrl.onPaypalSuccess(params)"\n        on-cancel="$ctrl.onPaypalCancel()"\n        currency="$ctrl.currency"\n        validate-form="$ctrl.validateForm()"\n      ></cp-paypal-widget>\n\n       <cp-paypal-commerce-widget\n        data-ng-if="$ctrl.show.paypalCommerce() || $ctrl.show.venmo()"\n        has-paypal="$ctrl.show.paypalCommerce()"\n        has-venmo="$ctrl.show.venmo()"\n        model-paypal="$ctrl.payment.paypal_commerce"\n        model-venmo="$ctrl.payment.venmo"\n        amount="$ctrl.parentModel.items[0].raw_final_price"\n        fot="$ctrl.parentModel.fee_on_top"\n        frequency="$ctrl.parentModel.frequency"\n        on-success="$ctrl.onPaypalCommerceSuccess(params)"\n        on-open="$ctrl.onPaypalCommerceOpen(params)"\n        on-cancel="$ctrl.onPaypalCommerceCancel()"\n        validate-form="$ctrl.validateForm()"\n      ></cp-paypal-commerce-widget>\n  \n      <button \n        data-tracked-element="donation-page_checkout_credit-card-btn" \n        class="payment-method-select-btn__cc" \n        type="button" style="background:{{$ctrl.theme.styles.primaryColor}}" \n        ng-click="$ctrl.showCardInputs()"\n        aria-expanded="{{$ctrl.meta.showPaymentDetails}}"\n        aria-controls="donation-page_checkout_payment-form donation-page_checkout_payment-details"\n        data-id="paymethod-card"\n      >Debit or Credit</button>\n\n      <cp-plaid-widget\n        data-ng-if="$ctrl.show.achButton() && !$ctrl.isTrial"&\n        model="$ctrl.payment.ach"\n        sc-validity-reporter\n        ng-model="$ctrl.payment.ach.status"\n        on-ready="$ctrl.onAchReady()"\n        on-success="$ctrl.onAchSuccess(lastFour, accountType)"\n        on-cancel="$ctrl.onAchCancel()"\n        currency="$ctrl.currency"\n        validate-form="$ctrl.validateForm()"\n      ></cp-plaid-widget>\n\n      <button \n        data-tracked-element="donation-page_checkout_account-routing-btn" \n        type="button" \n        class="payment-method-select-btn__ach" \n        style="background:{{$ctrl.theme.styles.primaryColor}}" \n        ng-click="$ctrl.showAccountRouting()" \n        ng-if="$ctrl.show.accountRoutingButton() && !$ctrl.isTrial"\n        aria-expanded="{{$ctrl.meta.showPaymentDetails}}"\n        aria-controls="donation-page_checkout_payment-form donation-page_checkout_payment-details"\n        data-id="paymethod-ach"\n      >Bank Account</button>\n\n      <button\n        data-tracked-element="donation-page_checkout_cryptocurrency-btn"\n        type="submit"\n        class="payment-method-select-btn__crypto"\n        style="background:{{$ctrl.theme.styles.primaryColor}}"\n        ng-click="$ctrl.cryptoCheckout()"\n        ng-if="$ctrl.show.crypto() && !$ctrl.isTrial"\n        data-id="paymethod-crypto"\n      >Cryptocurrency</button>\n\n      <chariot-wrapper\n        ng-if="$ctrl.shouldShowDaf && $ctrl.parentModel.frequency === \'one-time\' && $ctrl.cid"\n        cid="{{$ctrl.cid}}"\n        theme="gradient" \n        on-donation-request="handleDonationRequest(detail)"\n        on-success="$ctrl.handleSuccess(detail)"\n        on-exit="$ctrl.handleExit(event)"\n        on-error="handleError(event)"\n        validate-form="$ctrl.validateForm()"\n        amount="$ctrl.getAmount()"\n        parent-model="$ctrl.parentModel"\n        >\n      </chariot-wrapper>\n\n    </div>\n  </div>\n\n  <div class="donation-border-top" ng-if="$ctrl.meta.showPaymentDetails"></div>\n  \n  <div ng-if="$ctrl.meta.showPaymentDetails" id="donation-page_checkout_payment-details">\n    <h2 class="donation-subtitle" id="donationPage_payment-details-heading">Payment Details</h2>\n    <cp-payment-details\n      label="$ctrl.getPaymentLabel()"\n      details="$ctrl.paymentDetails"\n      payment-method="$ctrl.getPaymentMethod()"\n      payment="$ctrl.payment"\n      show="$ctrl.show"\n      on-token="$ctrl.handleTokenexToken(token)"\n      on-card="$ctrl.handleTokenexCard(brand, lastFour)"\n      primary-color="$ctrl.theme.styles.primaryColor"\n      hide-postal="$ctrl.hidePostal"\n      currency="$ctrl.currency"\n    ></cp-payment-details>\n\n    <cp-donate-footer \n      donation-frequency="$ctrl.parentModel.frequency"\n      donation-currency="$ctrl.parentModel.payment.raw_currency_code"\n      donation-amount="$ctrl.meta.summaryAmount"\n      btn-color="$ctrl.theme.styles.primaryColor">\n    </cp-donate-footer>\n  </div>\n  ',
  bindings: {
    payment: '<',
    parentModel: '<',
    meta: '<',
    feeProcessing: '<',
    submitDigitalWallets: '<',
    api: '=',
    hidePostal: '<',
    disabledPaymentMethods: '<',
    currency: '<',
    validateForm: '<',
    submitDafPay: '<'
  },
  controller: ["$window", "$q", "$rootScope", "$timeout", "$http", "$state", "scThemesService", "cpConstants", "cpAPI", "scOrganizationsService", "scDigitalWalletsService", "scCurrencyService", "scCampaignsService", "scAnalytics", "scBanner", "PayPalSDK", "CryptoGiving", function controller($window, $q, $rootScope, $timeout, $http, $state, scThemesService, cpConstants, cpAPI, scOrganizationsService, scDigitalWalletsService, scCurrencyService, scCampaignsService, scAnalytics, scBanner, PayPalSDK, CryptoGiving) {
    var _this = this;

    this.isTrial = scOrganizationsService.getOrgStatus() === 'trial';

    /* Utils
    ========================================================= */
    this.getPaymentMethodStatus = function (processors, paymentMethod) {
      return processors[paymentMethod] && !_this.disabledPaymentMethods.includes(paymentMethod) ? STATUS.READY : STATUS.INACTIVE;
    };

    /* Setup
    ========================================================= */
    var STATUS = cpConstants.STATUS,
        EVENTS = cpConstants.EVENTS,
        PAYMENT_METHODS = cpConstants.PAYMENT_METHODS;

    this.eventCallbacks = {};
    this.theme = scThemesService.active.current;
    this.STATUS = STATUS;
    this.PAYMENT_METHODS = PAYMENT_METHODS;
    this.EVENTS = EVENTS;
    this.selectedCurrency = '';
    this.arePaymentButtonEnabled = true;

    this.handleSuccess = function (detail) {
      _this.payment.method = 'DAFPay';
      _this.payment.gateway = 'DAFPay';
      _this.submitDafPay(detail);
    };

    this.handleExit = function (event) {
      scBanner('Your DAFPay payment was not completed. Please try again.', 'error');
      scAnalytics.track('CHARIOT EXIT', {
        description: event.detail.description,
        workflowSessionId: event.detail.workflowSessionId
      });
    };

    this.disablePaymentButtons = function () {
      var _this2 = this;

      $timeout(function () {
        _this2.arePaymentButtonEnabled = false;
        $timeout(function () {
          // re-enable buttons after 5 seconds
          _this2.arePaymentButtonEnabled = true;
        }, 5000);
      });
    };
    this.enablePaymentButtons = function () {
      var _this3 = this;

      $timeout(function () {
        _this3.arePaymentButtonEnabled = true;
      });
    };

    this.paymentTypeInitStatus = function (type) {
      return _.get(_this.payment, type + '.status') || STATUS.INACTIVE;
    };

    this.$onInit = function () {
      _this.api = _this.api || {};
      _this.parentModel = _this.parentModel || {};

      _this.disabledPaymentMethods = _this.disabledPaymentMethods || [];
      _this.isDonationCheckoutPage = !!$state.current.name.includes('frs.donation.checkout');

      _this.api.setModelPayment = _this.setModelPayment.bind(_this);
      _this.api.getPaymentLabel = _this.getPaymentLabel.bind(_this);
      _this.api.reloadTokenexIframe = _this.reloadTokenexIframe.bind(_this);
      _this.api.resetPaymentMethod = _this.resetPaymentMethod.bind(_this);
      _this.api.getPaymentMethod = _this.getPaymentMethod.bind(_this);
      _this.api.setModelPaymentMethodGateway = _this.setModelPaymentMethodGateway.bind(_this);
      _this.api.showFeeOnTopAndTerms = _this.showFeeOnTopAndTerms.bind(_this);

      _this.getProcessors().then(function (processors) {
        _this.processors = processors;
        _this.isPaypalReady = _.get(_this.payment.paypal, 'status', null) !== null;
        _this.initPaymentMethodStatuses(_this.isPaypalReady);
        if (_this.isStripeOrCCOnly()) {
          _this.showPaymentDetails();
          _this.hideButtons = true;
        }

        var isStripeACH = _.get(_this.processors, 'ACH.name', null) === 'STRIPE';
        _this.achAccountRoutingEnabled = SC.organization.achAccountRoutingEnabled && isStripeACH;
      });

      _this.paymentDetails = '';
      _this.isClassyMode = scCampaignsService.active.current.classy_mode_enabled;

      _this.hasDafPayTag = !!scOrganizationsService.getTag('early-access:dafpay', true);
      _this.shouldShowDaf = _this.hasDafPayTag && SC.campaign.daf_enabled;

      if (_this.shouldShowDaf) {
        _this.getChariotIntegration().then(function (result) {
          _this.cid = result.chariot_connect_id;
        }).catch(function () {
          // eslint-disable-next-line no-console
          console.error('Chariot integration for Org ' + SC.organization.id + ' was not found');
        });
      }
    };

    this.getChariotIntegration = function () {
      return $http.get('/frs-api/organizations/' + SC.organization.id + '/chariot/integration').then(function (response) {
        return response.data;
      });
    };

    this.$onChanges = function (_ref) {
      var currency = _ref.currency;

      if (currency && currency.isFirstChange()) {
        // Determine/store the selected currency. This also determines whether Paypal is rendered/shown.
        // The first onChange event on load of the page sets this to the campaign currency.
        // The second onChange event depends on whether the page is being viewed in preview mode.
        // 1. Non-preview mode: changes currency to a currency based on the browser language, or will not fire if it is the same as the first one.
        // 2. Preview mode: changes currency to the campaign currency.
        var currentStateName = $state.current.name;
        if (currentStateName.indexOf('setup') > -1 || currentStateName.indexOf('create') > -1 || currentStateName.indexOf('design') > -1 || SC.preview) {
          // Preview mode, set our first currency value to the campaign currency
          _this.selectedCurrency = scCurrencyService.getEntityCurrency(scCampaignsService.active.current);
        } else {
          // Non-preview mode, set our first currency value to the locale currency.
          _this.selectedCurrency = scCurrencyService.localeCurrency;
        }
      }

      // don't worry about first uninitialized value or when currency is undefined
      if (!currency || currency.isFirstChange()) return;

      // Succeeding changes, we use the same value the picker loads with or the user selects.
      _this.selectedCurrency = currency.currentValue;

      // if org doesn't have paypal commerce, venmo, and ach, we don't need to do anything
      if (!_.has(_this.processors, PAYMENT_METHODS.ACH) && !_.has(_this.processors, PAYMENT_METHODS.PAYPAL_COMMERCE) && !_.has(_this.processors, PAYMENT_METHODS.VENMO)) return;

      if (currency.currentValue !== 'USD') {
        // if ach, paypal commerce, or venmo was selected, lets clear the values and hide the bottom of the form
        var paymentMethod = _this.getPaymentMethod();
        if (paymentMethod === PAYMENT_METHODS.ACH || paymentMethod === PAYMENT_METHODS.PAYPAL_COMMERCE || paymentMethod === PAYMENT_METHODS.VENMO) {
          _this.hidePaymentDetails();
          _this.initPaymentMethodStatuses();
        }
        _this.disabledPaymentMethods.push(PAYMENT_METHODS.ACH);
        _this.disabledPaymentMethods.push(PAYMENT_METHODS.PAYPAL_COMMERCE);
        _this.disabledPaymentMethods.push(PAYMENT_METHODS.VENMO);

        _this.payment.ach.status = STATUS.INACTIVE;
        _this.payment.paypal_commerce.status = STATUS.INACTIVE;
        _this.payment.venmo.status = STATUS.INACTIVE;

        // if ach was only other button besides cc, just show normal form
        // or if paypal commerce was only other button besides cc, just show normal form
        // or if venmo was only button besides cc, just show normal form
        if (_this.isStripeOrCCAndACHOnly() || _this.isStripeOrCCAndPayPalCommerceOnly() || _this.isStripeOrCCAndVenmoOnly()) {
          _this.showPaymentDetails();
          _this.hideButtons = true;
        }
      } else {
        // remove ACH, PayPal Commerce, and venomo from disabled payment methods
        _this.disabledPaymentMethods = _this.disabledPaymentMethods.filter(function (paymentMethod) {
          return paymentMethod !== PAYMENT_METHODS.ACH && paymentMethod !== PAYMENT_METHODS.PAYPAL_COMMERCE && paymentMethod !== PAYMENT_METHODS.VENMO;
        });
        _this.initPaymentMethodStatuses();
        _this.hideButtons = false;
      }
    };

    this.showDigitalWalletsListener = function (show) {
      _this.showDW = show;
      if (!show && _this.isStripeOrCCAndDigitalWalletsOnly()) {
        _this.showPaymentDetails();
        _this.hideButtons = true;
      }
    };

    scDigitalWalletsService.addShowDigitalWalletsListener(this.showDigitalWalletsListener);

    scDigitalWalletsService.addOnDigitalWalletsSubmitListener(function () {
      _this.initPaymentMethodStatuses();
    });

    this.onOpenDigitalWalletModalListener = function () {
      _this.initPaymentMethodStatuses();

      _this.payment.stripe.status = STATUS.READY;

      _this.paymentDetails = '';
      _this.hidePaymentDetails();
      $rootScope.$broadcast('donationPage:recalculateFees');
    };

    scDigitalWalletsService.addOnOpenDigitalWalletModalListener(this.onOpenDigitalWalletModalListener);

    /* External Api
    ========================================================= */
    this.setModelPayment = function () {
      var paymentMethod = _this.setModelPaymentMethodGateway();
      var paymentPromise = void 0;

      switch (paymentMethod) {
        case PAYMENT_METHODS.CC:
          {
            paymentPromise = _this.getTokenexToken();
            break;
          }

        case PAYMENT_METHODS.STRIPE:
          {
            paymentPromise = _this.payment.stripe.getSource();
            break;
          }

        case PAYMENT_METHODS.ACH:
          {
            paymentPromise = _this.achAccountRoutingEnabled ? _this.getTokenexToken() : $q.resolve();
            break;
          }

        case PAYMENT_METHODS.PAYPAL:
        case PAYMENT_METHODS.PAYPAL_COMMERCE:
        case PAYMENT_METHODS.VENMO:
          {
            paymentPromise = $q.resolve();
            break;
          }

        default:
          return $q.reject(new Error('invalid payment method'));
      }

      return paymentPromise;
    };

    this.getPaymentLabel = function () {
      switch (_this.getPaymentMethod()) {
        case PAYMENT_METHODS.STRIPE:
        case PAYMENT_METHODS.CC:
          {
            return 'Card Number';
          }

        case PAYMENT_METHODS.ACH:
          {
            return 'Bank Info';
          }

        case PAYMENT_METHODS.PAYPAL_COMMERCE:
        case PAYMENT_METHODS.PAYPAL:
          {
            return 'Paypal Account';
          }

        case PAYMENT_METHODS.VENMO:
          {
            return 'Venmo Account';
          }

        default:
          return 'Payment';
      }
    };

    this.getProcessors = function () {
      if ($window.SC.processors) return $q.resolve($window.SC.processors);

      return $http.get('/frs-api/pay/processors?appId=' + cpAPI.getApplicationId()).then(function (response) {
        return response.data;
      });
    };

    // we only show feeOnTop and terms in the footer if the donation page only takes credit card,
    // or if they take credit card and have digital wallets enabled, but browser/user does not support DW
    this.showFeeOnTopAndTerms = function () {
      return _this.isStripeOrCCOnly() || _this.isStripeOrCCAndDigitalWalletsOnly() && !_this.showDw || _this.isStripeOrCCAndACHOnly() && _this.currency !== 'USD';
    };

    /* Internal Methods
    ========================================================= */
    this.initPaymentMethodStatuses = function (isPaypalReady) {
      // wrapping in a $timeout to force a separate change detection cycle tick, otherwise UI will not show paypal or plaid widgets when cancelling them

      /* Adding this condition to prevent Paypal button from appearing twice */
      if (!isPaypalReady || _this.payment.paypal.status === STATUS.PENDING) {
        _this.payment.paypal = {
          status: _this.getPaymentMethodStatus(_this.processors, PAYMENT_METHODS.PAYPAL)
        };
      }

      _this.payment.paypal_commerce = {
        status: _this.getPaymentMethodStatus(_this.processors, PAYMENT_METHODS.PAYPAL_COMMERCE)
      };

      _this.payment.venmo = {
        status: _this.getPaymentMethodStatus(_this.processors, PAYMENT_METHODS.VENMO)
      };

      _this.payment.ach = {
        status: _this.getPaymentMethodStatus(_this.processors, PAYMENT_METHODS.ACH)
      };

      // Only override status on reinitializing processors since we could end up deleting
      // api properties set by stripeWidget component (like getSource)
      _this.payment.stripe = Object.assign(_this.payment.stripe || {}, {
        status: _this.getPaymentMethodStatus(_this.processors, PAYMENT_METHODS.STRIPE)
      });

      _this.payment.cc = {
        status: _this.getPaymentMethodStatus(_this.processors, PAYMENT_METHODS.CC)
      };

      // scFeeOnTopService.setAmex(false);
    };

    this.resetPaymentMethod = function () {
      // Won't do anything for the Standard Donation page.
    };

    this.getAmount = function () {
      if (_this.isClassyMode) {
        return _this.meta.summaryAmount;
      } else {
        return _this.parentModel.items[0].raw_final_price;
      }
    };

    this.getPaymentMethod = function () {
      if (_this.paymentTypeInitStatus('paypal') === STATUS.SUCCESS) {
        return PAYMENT_METHODS.PAYPAL;
      } else if (_this.paymentTypeInitStatus('paypal_commerce') === STATUS.SUCCESS || _this.paymentTypeInitStatus('paypal_commerce') === STATUS.OPEN) {
        return PAYMENT_METHODS.PAYPAL_COMMERCE;
      } else if (_this.paymentTypeInitStatus('venmo') === STATUS.SUCCESS || _this.paymentTypeInitStatus('venmo') === STATUS.OPEN) {
        return PAYMENT_METHODS.VENMO;
      } else if (_this.paymentTypeInitStatus('ach') === STATUS.SUCCESS) {
        return PAYMENT_METHODS.ACH;
      } else if (_this.show.stripe()) {
        return PAYMENT_METHODS.STRIPE;
      } else if (_this.isDigitalWallet()) {
        return PAYMENT_METHODS.STRIPE;
      }

      return PAYMENT_METHODS.CC;
    };

    // refactor into a nice function at some point lol
    this.isStripeOrCCOnly = function () {
      return !_.has(_this.processors, PAYMENT_METHODS.DW) && !_.has(_this.processors, PAYMENT_METHODS.ACH) && !_.has(_this.processors, PAYMENT_METHODS.PAYPAL) && !_.has(_this.processors, PAYMENT_METHODS.PAYPAL_COMMERCE) && !_.has(_this.processors, PAYMENT_METHODS.VENMO) && !CryptoGiving.enabled();
    };

    this.isStripeOrCCAndDigitalWalletsOnly = function () {
      return _.has(_this.processors, PAYMENT_METHODS.DW) && !_.has(_this.processors, PAYMENT_METHODS.ACH) && !_.has(_this.processors, PAYMENT_METHODS.PAYPAL) && !_.has(_this.processors, PAYMENT_METHODS.PAYPAL_COMMERCE) && !_.has(_this.processors, PAYMENT_METHODS.VENMO) && !CryptoGiving.enabled();
    };

    this.isStripeOrCCAndACHOnly = function () {
      return _.has(_this.processors, PAYMENT_METHODS.ACH) && !_.has(_this.processors, PAYMENT_METHODS.DW) && !_.has(_this.processors, PAYMENT_METHODS.PAYPAL) && !_.has(_this.processors, PAYMENT_METHODS.PAYPAL_COMMERCE) && !_.has(_this.processors, PAYMENT_METHODS.VENMO) && !CryptoGiving.enabled();
    };

    this.isStripeOrCCAndPayPalCommerceOnly = function () {
      return _.has(_this.processors, PAYMENT_METHODS.PAYPAL_COMMERCE) && !_.has(_this.processors, PAYMENT_METHODS.ACH) && !_.has(_this.processors, PAYMENT_METHODS.DW) && !_.has(_this.processors, PAYMENT_METHODS.PAYPAL) && !_.has(_this.processors, PAYMENT_METHODS.VENMO) && !CryptoGiving.enabled();
    };

    this.isStripeOrCCAndVenmoOnly = function () {
      return _.has(_this.processors, PAYMENT_METHODS.VENMO) && !_.has(_this.processors, PAYMENT_METHODS.ACH) && !_.has(_this.processors, PAYMENT_METHODS.DW) && !_.has(_this.processors, PAYMENT_METHODS.PAYPAL) && !_.has(_this.processors, PAYMENT_METHODS.VENMO) && !CryptoGiving.enabled();
    };

    this.showPaymentDetails = function () {
      _this.meta.showPaymentDetails = true;
    };

    this.scrollToPaymentDetails = function () {
      // Wait one second for the payment details to render before scrolling to it
      $timeout(function () {
        var targetElement = document.getElementById('donation-page_checkout_payment-details');

        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth' });
        }
      }, 1000);
    };

    this.hidePaymentDetails = function () {
      _this.meta.showPaymentDetails = false;
    };

    this.showCardInputs = function () {
      _this.payment.cc.status = STATUS.READY;
      _this.payment.stripe.status = STATUS.READY;
      _this.payment.stripe.source = null;
      _this.initPaymentMethodStatuses();
      _this.showPaymentDetails();
      _this.scrollToPaymentDetails();

      $rootScope.$broadcast('checkPaymentAuthStatus', false);
      $rootScope.$broadcast('donationPage:recalculateFees');
      _this.paymentDetails = '';
    };

    this.showAccountRouting = function () {
      _this.initPaymentMethodStatuses();
      _this.payment.ach.status = STATUS.SUCCESS;
      _this.payment.cc.status = STATUS.PENDING;
      _this.payment.stripe.status = STATUS.PENDING;
      _this.payment.stripe.source = null;
      _this.showPaymentDetails();
      _this.scrollToPaymentDetails();
      _this.paymentDetails = '';
      $rootScope.$broadcast('checkPaymentAuthStatus', true);
      $rootScope.$broadcast('donationPage:recalculateFees');
    };

    this.resetAccountRouting = function () {
      _this.payment.ach = {
        status: STATUS.SUCCESS
      };
    };

    this.cryptoCheckout = function () {
      var path = '/frs-api/campaign/' + scCampaignsService.active.current.id + '/cg-checkout';
      this.meta.paymentType = 'CRYPTO';
      var payload = {
        application_id: scOrganizationsService.getTag('classyPayApplicationId'),
        amount: this.meta.summaryAmount,
        currency: this.currency ? this.currency : 'USD',
        member_first_name: this.meta.member_first_name,
        member_last_name: this.meta.member_last_name,
        member_email_address: this.parentModel.member_email_address,
        billing_postal_code: this.parentModel.billing_postal_code,
        opt_in: this.parentModel.opt_in,
        opt_in_wording: this.parentModel.opt_in_wording,
        hide_amount: !!this.parentModel.hide_amount,
        is_anonymous: !!this.parentModel.is_anonymous,
        location: window.location.origin + window.location.pathname
      };

      // Full validation will still run when the button is clicked, but we should also  exit early
      // on obvious errors to avoid a flash when opening & closing a blank window.
      if (!(payload.amount && payload.member_first_name && payload.member_last_name && payload.member_email_address && payload.billing_postal_code)) return;

      // opening a new window immediately after user click is
      // a trusted event, which avoids triggering popup blockers
      var popup = window.open();
      var success = false;
      var chargeId = void 0;
      var draftId = void 0;
      $http.post(path, payload).then(function (response) {
        if (response.status == 200) {
          popup.location = response.data.url;
          chargeId = response.data.url.split('/').pop();
          draftId = response.data.draftId;
          success = true;
        }
      }).finally(function () {
        if (success) {
          var pollStatusAndRedirect = function pollStatusAndRedirect() {
            $http.get('/frs-api/crypto-giving/' + chargeId + '/status').then(function (response) {
              var status = response.data.status;
              if (status === 'charge:pending' || status === 'charge:confirmed') {
                var transactionData = {
                  id: draftId,
                  raw_currency_code: payload.currency,
                  raw_total_gross_amount: payload.amount,
                  charged_currency_code: payload.currency,
                  charged_total_gross_amount: payload.amount,
                  frequency: 'one-time'
                };
                $state.go('frs.donation.thankYou', { tid: draftId, transactionData: transactionData });
              } else {
                setTimeout(pollStatusAndRedirect, 20000); // 20 seconds
              }
            });
          };
          setTimeout(pollStatusAndRedirect, 60000); // 60 seconds
        } else {
          popup.close();
          $rootScope.SC.status.banner = {
            type: 'error',
            msg: 'There was an error.',
            timeout: false
          };
        }
      });
    };

    this.setModelPaymentMethodGateway = function () {
      var isDigitalWallets = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var paymentMethod = isDigitalWallets ? PAYMENT_METHODS.STRIPE : _this.getPaymentMethod();
      _this.payment.method = paymentMethod;
      _this.payment.gateway = _this.processors[paymentMethod];
      return paymentMethod;
    };

    this.isDigitalWallet = function () {
      if (!_this.payment || !_this.payment.stripe || !_this.payment.stripe.source) {
        return false;
      }

      // Check for DW specific identifiers in the payment method
      // https://docs.stripe.com/api/payment_methods/object#payment_method_object-card-wallet
      var paymentMethod = _this.payment.stripe.source;

      return paymentMethod.type === 'card' && paymentMethod.card && paymentMethod.card.wallet;
    };

    // NOTE: cc + stripe / paypal + paypal commerce are the only payment methods that are intrinsically linked with the other
    // This means, one cannot be shown simultaneously with the other. That is why the logic for their show()
    // methods references properties of each other.
    this.show = {
      cc: function cc() {
        if (_this.isDigitalWallet()) return false;

        var stripeCurrencyOverride = _.get(_this.processors, [PAYMENT_METHODS.STRIPE, 'currency']);
        var ccCurrencyOverride = _.get(_this.processors, [PAYMENT_METHODS.CC, 'currency']);
        if (_this.paymentTypeInitStatus('cc') !== STATUS.READY) return false;

        // There is a chance the org still has an old processor active, but under the same currency as
        // Stripe, so we need to hide the tokenex iframe.
        if (_this.currency === stripeCurrencyOverride) return false;

        // If the currency matches for CC but not Stripe, we assume the org wants to show tokenex for this
        // specific currency
        if (_this.currency === ccCurrencyOverride) return true;

        // If the currency is not the default currency for CC BUT the org is not on Stripe,
        // then we show tokenex anyway, as the currency will be converted to the org's
        // default currency
        return _this.paymentTypeInitStatus('stripe') !== STATUS.READY;
      },
      stripe: function stripe() {
        if (_this.isDigitalWallet()) return false;

        var stripeCurrencyOverride = _.get(_this.processors, [PAYMENT_METHODS.STRIPE, 'currency']);
        var ccCurrencyOverride = _.get(_this.processors, [PAYMENT_METHODS.CC, 'currency']);

        if (_this.paymentTypeInitStatus('stripe') !== STATUS.READY) return false;

        if (_this.currency === stripeCurrencyOverride) return true;

        // Stripe always supercedes other processors for credit card transactions UNLESS that
        // processor explicitly lists the selected currency as it's default currency
        return _this.currency !== ccCurrencyOverride;
      },
      achButton: function achButton() {
        return _this.paymentTypeInitStatus('ach') !== STATUS.INACTIVE && !_this.achAccountRoutingEnabled;
      },
      ach: function ach() {
        return _this.paymentTypeInitStatus('ach') === STATUS.SUCCESS && !_this.achAccountRoutingEnabled;
      },
      accountRoutingButton: function accountRoutingButton() {
        return _this.paymentTypeInitStatus('ach') !== STATUS.INACTIVE && _this.achAccountRoutingEnabled;
      },
      accountRouting: function accountRouting() {
        return [STATUS.SUCCESS].includes(_this.paymentTypeInitStatus('ach')) && _this.achAccountRoutingEnabled;
      },
      paypal: function paypal() {
        var paypalCurrencyOverride = _.get(_this.processors, [PAYMENT_METHODS.PAYPAL, 'currency']);

        // if paypal is inactive, dont show
        if (_this.paymentTypeInitStatus('paypal') === STATUS.INACTIVE) return false;

        // if bt paypal is active and paypal commerce is inactive, always show bt paypal
        if (_this.paymentTypeInitStatus('paypal_commerce') === STATUS.INACTIVE) return true;

        // If paypal commerce is active and currency is USD, default to PayPal Commerce
        if (_this.selectedCurrency === 'USD') return false;

        // If the currency is not USD and matches for BT PayPal show BT PayPal
        if (_this.selectedCurrency === paypalCurrencyOverride) return true;

        // If its not inactive, show
        return _this.paymentTypeInitStatus('paypal') !== STATUS.INACTIVE;
      },
      paypalCommerce: function paypalCommerce() {
        return _this.selectedCurrency === 'USD' && _this.paymentTypeInitStatus('paypal_commerce') !== STATUS.INACTIVE;
      },
      venmo: function venmo() {
        return _this.selectedCurrency === 'USD' && _this.paymentTypeInitStatus('venmo') !== STATUS.INACTIVE;
      },
      crypto: function crypto() {
        return _this.parentModel.frequency === 'one-time' && CryptoGiving.enabled();
      }
    };

    this.loggedIn = function () {
      return [_this.paymentTypeInitStatus('paypal'), _this.paymentTypeInitStatus('ach')].includes(STATUS.SUCCESS);
    };

    this.getRelevantCurrency = function () {
      return _this.meta.unsupportedTaxCompliance ? _.get(_this.meta, 'estimatedCharge.currency', false) : _this.payment.raw_currency_code;
    };

    this.on = function (event, cb) {
      var cbs = _.get(_this.eventCallbacks, event, []);
      cbs.push(cb);
      _.set(_this.eventCallbacks, event, cbs);
    };

    this.once = function (event, cb) {
      cb.once = true;
      _this.on(event, cb);
    };

    this.emit = function (event) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      console.log(event); // eslint-disable-line no-console
      $timeout(function () {
        var cbs = _.get(_this.eventCallbacks, event, []);
        _.forEach(cbs, function (cb) {
          return cb.apply(undefined, args);
        });
        _.remove(cbs, 'once');
      });
    };

    this.terms = function () {
      var orgData = scOrganizationsService.active.current;

      var orgPrivacyPolicyUrl = orgData.privacy_policy_url;
      var orgUrl = orgData.url;

      if (orgPrivacyPolicyUrl) {
        return 'We partner with GoFundMe to power this page. By donating, you agree to our <a href=' + orgPrivacyPolicyUrl + ' target="_blank">Privacy Policy</a>, along with the <a href="https://pro.gofundme.com/c/legal/terms" target="_blank">GoFundMe Terms</a> and <a href="https://pro.gofundme.com/c/legal/privacy-notice" target="_blank">GoFundMe Privacy Notice</a>.';
      } else if (orgUrl) {
        return 'We partner with GoFundMe to power this page. By donating, you agree to our <a href=' + orgUrl + ' target="_blank">Privacy Policy</a>, along with the <a href="https://pro.gofundme.com/c/legal/terms" target="_blank">GoFundMe Terms</a> and <a href="https://pro.gofundme.com/c/legal/privacy-notice" target="_blank">GoFundMe Privacy Notice</a>.';
      } else {
        return 'We partner with GoFundMe to power this page. By donating, you agree to <a href="https://pro.gofundme.com/c/legal/terms" target="_blank">GoFundMe Terms</a> and <a href="https://pro.gofundme.com/c/legal/privacy-notice" target="_blank">GoFundMe Privacy Notice</a>.';
      }
    };

    /* Tokenex
    ========================================================= */
    this.handleTokenexCard = function (brand, lastFour) {
      _this.payment.cc = _this.payment.cc || {};
      _this.payment.cc.card_type = brand;
      _this.payment.cc.card_last_four = lastFour;
    };

    this.handleTokenexToken = function (token) {
      this.activeSubmit.resolve(token);
    };

    this.getTokenexToken = function () {
      _this.activeSubmit = $q.defer();
      $rootScope.$broadcast('tokenizer', 'tokenize');
      return _this.activeSubmit.promise.catch(function (err) {
        $rootScope.SC.status.banner = {
          type: 'error',
          msg: 'Please check your payment information and try again.',
          timeout: false
        };
        return $q.reject(err);
      });
    };

    this.reloadTokenexIframe = function () {
      $rootScope.$broadcast('tokenizer', 'reset');
      if (_this.getPaymentMethod() === PAYMENT_METHODS.ACH && _this.achAccountRoutingEnabled) {
        _this.resetAccountRouting();
      } else {
        _this.initPaymentMethodStatuses();
      }
    };

    /* Stripe
    ========================================================= */
    // stripe is handled internally by the cpStripeWidget. The
    // only external method needed is payment.stripe.getSource
    // which is called by this.setModelPayment during form
    // submission

    /* ACH
    ========================================================= */
    this.onAchReady = function () {
      console.log('ACH Ready'); // eslint-disable-line no-console
      _this.payment.paypal.status = STATUS.READY;
    };

    this.onAchSuccess = function (lastFour, accountType) {
      $timeout(function () {
        _this.paymentDetails = accountType.charAt(0).toUpperCase() + accountType.slice(1) + ' Account ending in ' + lastFour;
        console.log('ACH Success'); // eslint-disable-line no-console
        _this.showPaymentDetails();
        $rootScope.$broadcast('checkPaymentAuthStatus', true);
        $rootScope.$broadcast('donationPage:recalculateFees');
        _this.payment.cc.status = STATUS.PENDING;
        _this.payment.stripe.status = STATUS.PENDING;
      });
    };

    this.onAchCancel = function () {
      console.log('ACH Cancel'); // eslint-disable-line no-console
      $rootScope.$broadcast('checkPaymentAuthStatus', false);
      $rootScope.$broadcast('donationPage:recalculateFees');
      _this.initPaymentMethodStatuses();
    };

    /* PayPal
    ========================================================= */
    this.onPaypalReady = function () {
      console.log('PayPal Ready'); // eslint-disable-line no-console
      _this.payment.paypal.status = _this.payment.paypal.status === STATUS.PENDING ? STATUS.READY : _this.payment.paypal.status;
    };

    // Todo: handle hiding billing address autocomplete on paypal success
    this.onPaypalSuccess = function (params) {
      $timeout(function () {
        _this.paymentDetails = params.details.email;
        console.log('PayPal Success'); // eslint-disable-line no-console
        _this.showPaymentDetails();
        _this.payment.cc.status = STATUS.PENDING;
        _this.payment.stripe.status = STATUS.PENDING;
        Object.assign(_this.payment.paypal, params.details);

        if (_this.parentModel) {
          _.forEach({
            billing_first_name: 'firstName',
            billing_last_name: 'lastName',
            member_email_address: 'email'
          }, function (ppKey, modelKey) {
            if (!_this.parentModel[modelKey]) {
              _this.parentModel[modelKey] = _.get(params.details, ppKey);
            }
          });
        }

        $rootScope.$broadcast('checkPaymentAuthStatus', true);
        $rootScope.$broadcast('donationPage:recalculateFees');
      });
    };

    this.onPaypalCancel = function () {
      console.log('PayPal Cancel'); // eslint-disable-line no-console
      $rootScope.$broadcast('checkPaymentAuthStatus', false);
      $rootScope.$broadcast('donationPage:recalculateFees');
      _this.initPaymentMethodStatuses();
    };

    this.onPaypalCommerceSuccess = function (_ref2) {
      var details = _ref2.details,
          fundingSource = _ref2.fundingSource;

      $timeout(function () {
        _this.initPaymentMethodStatuses();
        _this.paymentDetails = details.email;
        console.log('PayPal Commerce Success'); // eslint-disable-line no-console
        _this.showPaymentDetails();
        _this.payment.cc.status = STATUS.PENDING;
        _this.payment.stripe.status = STATUS.PENDING;

        if (fundingSource && fundingSource === 'venmo') {
          Object.assign(_this.payment.venmo, details);
        } else {
          Object.assign(_this.payment.paypal_commerce, details);
        }
      }).then(PayPalSDK.autosubmitPayPalCommerce);
    };

    this.onPaypalCommerceCancel = function () {
      console.log('PayPal Commerce Cancel'); // eslint-disable-line no-console
      _this.enablePaymentButtons();
      _this.payment.cc.status = STATUS.READY;
      _this.payment.stripe.status = STATUS.READY;
      _this.initPaymentMethodStatuses();
      _this.hidePaymentDetails();

      $rootScope.$broadcast('checkPaymentAuthStatus', false);
      $rootScope.$broadcast('donationPage:recalculateFees');
    };

    this.onPaypalCommerceOpen = function (_ref3) {
      var paymentMethod = _ref3.paymentMethod;

      console.log('PayPal Commerce Open', paymentMethod); // eslint-disable-line no-console
      if (_this.getAmount() !== 0) {
        _this.disablePaymentButtons();
      }
      if (paymentMethod && paymentMethod === 'venmo') {
        _this.payment.venmo.status = STATUS.OPEN;
      } else {
        _this.payment.paypal_commerce.status = STATUS.OPEN;
      }

      _this.payment[paymentMethod].status = STATUS.OPEN;
      $rootScope.$broadcast('donationPage:recalculateFees');
    };
  }]
});
})();